import type React from 'react'
import type { JSX } from 'react'
import type { ITextBoxProps } from 'atoms/TextBox'
import type { CardContentTypeT, CardSizeT, CardTypeT } from 'blocks/Cards'
import type {
  GridLoadingByCardColumnGap,
  GridLoadingByCardPadding,
  GridLoadingByCardRowGap,
  GridLoadingByCardTitleMargin,
} from './GridLoadingByCard.h'

import { Children } from 'react'
import { TextBox, TextBoxColors, TextBoxTypes } from 'atoms/TextBox'
import { useSimpleVisibleCards } from 'containers/RowContainer/RowSimpleContainer/hooks/useSimpleVisibleCards'
import { useClientResolution } from 'utils/hooks'
import {
  GridLoadingByCardColumnGaps,
  GridLoadingByCardPaddings,
  GridLoadingByCardRowGaps,
  GridLoadingByCardTitleMargins,
} from './GridLoadingByCard.h'
import {
  GridLoadingByCardSC,
  GridLoadingByCardWrapperSC,
} from './GridLoadingByCard.styled'

export interface ISimpleGridLoadingByCardProps {
  children: React.ReactNode
  content: object[]
  rowGap?: GridLoadingByCardRowGap
  columnGap?: GridLoadingByCardColumnGap
  title?: ITextBoxProps['title']
  colorTitle?: ITextBoxProps['color']
  fontTitle?: ITextBoxProps['font']
  maxLineTitle?: ITextBoxProps['maxLines']
  paddings?: GridLoadingByCardPadding
  marginTitle?: GridLoadingByCardTitleMargin
  contentType: CardContentTypeT
  type: CardTypeT
  size: CardSizeT
}

export const SimpleGridLoadingByCard = ({
  children,
  content,
  rowGap = GridLoadingByCardRowGaps.DEFAULT,
  columnGap = GridLoadingByCardColumnGaps.DEFAULT,
  title,
  fontTitle = TextBoxTypes.Headline3,
  maxLineTitle = 1,
  paddings = GridLoadingByCardPaddings.SIZE_10,
  colorTitle = TextBoxColors.TEXT_ICON_PRIMARY,
  marginTitle = GridLoadingByCardTitleMargins.SIZE_10,
  contentType,
  type,
  size,
}: ISimpleGridLoadingByCardProps): JSX.Element | null => {
  const { width: clientWidth } = useClientResolution()

  const visibleCards = useSimpleVisibleCards({
    clientWidth,
    contentType,
    size,
    type,
  })

  return visibleCards && content?.length > 0 && Children.count(children) ? (
    <GridLoadingByCardWrapperSC paddings={paddings} marginTitle={marginTitle}>
      {title && (
        <TextBox
          color={colorTitle}
          maxLines={maxLineTitle}
          font={fontTitle}
          title={title}
        />
      )}
      <GridLoadingByCardSC
        rowGap={rowGap}
        columnGap={columnGap}
        cardsCount={visibleCards}
      >
        {children}
      </GridLoadingByCardSC>
    </GridLoadingByCardWrapperSC>
  ) : null
}
